<ng-container *ngIf="initialized">
<!--<div #codeMirrorHost></div>-->

    <div #editor class="cm-editor h-full" style="border: 1px solid #ddd;"></div>


</ng-container>